import Vue from 'vue';
import Router from 'vue-router';
import RouteView from '@/layouts/RouteView';
import Login from '@/pages/login/Login';
import {getRouterMap} from './lazyRouter';
import storage from "../utils/storage";

/*
 * 解决控制台打印错误问题，但是debug模式还是在错误处挂起
 * https://blog.csdn.net/qq_33430445/article/details/100689859
 */
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  // return originalPush.call(this, location).catch(err => err);
  return originalPush.call(this, location)
};

Vue.use(Router);

const router =  new Router({
  routes: [
    {
      path: '/',
      name: '登录页',
      component: Login,
      redirect: '/login',
      invisible: true
    },
    {
      path: '/login',
      name: '登录页',
      component: Login,
      invisible: true
    },
    {
      path: '/exception',
      name: '异常页',
      icon: 'warning',
      component: RouteView,
      children: [
        {
          path: '/exception/404',
          name: '404',
          icon: 'none',
          component: () => import('@/pages/exception/404')
        },
        {
          path: '/exception/403',
          name: '403',
          icon: 'none',
          component: () => import('@/pages/exception/403')
        },
        {
          path: '/exception/500',
          name: '500',
          icon: 'none',
          component: () => import('@/pages/exception/500')
        }
      ]
    },
  ]
});

/*
 * 参考 https://www.php.cn/js-tutorial-383908.html
 */
router.beforeEach((to, from, next) => {
  if (storage.get('user') == null) {
    const allRouter = getRouterMap();
    if (!['/', '/login', '/exception/404'].includes(to.path) && (allRouter.has(to.path) || to.matched.length)) {
      next({
        path: '/login',
        query: {redirect: to.fullPath}, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    } else if (['/', '/login', '/exception/404'].includes(to.path))  {
      next();
    } else {
      next({
        path: '/exception/404',
        query: {redirect: to.fullPath},
      });
    }
  } else {
    next();
  }
});

export default router;




// WEBPACK FOOTER //
// ./src/router/lazy.js